import { CanDeactivateFn } from '@angular/router';

/** Tela que pergunta antes de sair com edição não salva. */
export interface LeaveConfirmable {
  confirmLeave(nextUrl: string): boolean | Promise<boolean>;
}

/**
 * Sair de uma tela com edição não salva pergunta antes (o clique no menu jogava fora o que foi
 * digitado). A tela decide: implementa `confirmLeave` (em geral com `confirmLeaveWithChanges` de
 * `shared/utils/unsaved-changes.ts`). Arquivo próprio, sem importar componente: as rotas carregam as
 * telas sob demanda e o guard não pode puxá-las para o pacote inicial.
 */
export const unsavedChangesGuard: CanDeactivateFn<LeaveConfirmable> = (component, _route, _state, next) =>
  component?.confirmLeave ? component.confirmLeave(next?.url ?? '') : true;
